import React from 'react';

import guestIcon from './assets/bed.svg';
import coLivingIcon from './assets/person.svg';
import corporateIcon from './assets/briefcase.svg';
import hotelIcon from './assets/hotel.svg';
import {BOOKING_TYPE} from 'ducks/bookings';

const BOOKING_TYPES_ICONS = {
  [BOOKING_TYPE.CORPORATE]: corporateIcon,
  [BOOKING_TYPE.GUEST]: guestIcon,
  [BOOKING_TYPE.LONG_STAY]: coLivingIcon,
  [BOOKING_TYPE.EXTENDED_STAY]: hotelIcon
};

const BookingType = ({bookingType}) => (
  <div className="BookingType">
    <img src={BOOKING_TYPES_ICONS[bookingType]} alt="icon" />
  </div>
);

export default BookingType;
